// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/.store/css-loader@3.6.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ls-mask[data-v-4d85a5bc]{position:fixed;left:0;top:0;right:0;bottom:0;background-color:rgba(0,0,0,.5);z-index:99;display:flex;justify-content:center;align-items:flex-start}.ls-mask .ls-mask-inner[data-v-4d85a5bc]{margin-top:10vh;background-color:#fff;max-width:100vw;padding:10px;position:relative}.ls-mask .ls-mask-inner .tit[data-v-4d85a5bc]{font-size:1.2em}", ""]);
// Exports
module.exports = exports;
